import React from "react";
import { AlertTriangle, CalendarDays, MapPin, Loader2 } from "lucide-react";

export const LOGO_URL = "/assets/logo-detmold.png";
export const SKYLINE_URL = "/assets/skyline-grey.svg";

const SEVERITY_LABEL = { closure: "Vollsperrung", warning: "Engstelle", detour: "Umleitung" };
const SEVERITY_COLOR = { closure: "#DC2626", warning: "#F59E0B", detour: "#2563EB" };

export function formatPubDate(raw) {
  if (!raw) return "";
  try {
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return raw; }
}

export function ScreenLogoBar({ size = "md" }) {
  const h = size === "xl" ? "h-24" : size === "lg" ? "h-20" : "h-14";
  return (
    <div className="flex items-center min-w-0">
      <img src={LOGO_URL} alt="Stadt Detmold" className={`${h} w-auto shrink-0`} draggable={false} />
      <div className="border-l border-neutral-300 pl-4 ml-4 leading-tight whitespace-nowrap">
        <p className="text-[11px] uppercase tracking-[0.2em] text-[hsl(var(--brand-green-strong))] font-medium">
          Aktuelles aus Detmold
        </p>
      </div>
    </div>
  );
}

export function ScreenSkyline() {
  /** Skyline immer in voller natürlicher Höhe (kein Crop). */
  return (
    <div className="w-full pointer-events-none select-none" aria-hidden>
      <img
        src={SKYLINE_URL}
        alt=""
        className="w-full h-auto block"
        draggable={false}
      />
    </div>
  );
}

export function FallbackBackground() {
  return (
    <div
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(circle at 30% 20%, hsl(var(--brand-soft)) 0%, transparent 55%), radial-gradient(circle at 80% 80%, rgba(168,212,53,0.18) 0%, transparent 60%), linear-gradient(180deg, #F7F9F4 0%, #EFF3E8 100%)",
      }}
    />
  );
}

export function LoadingSlide({ orientation }) {
  return (
    <div className={`w-full h-full flex items-center justify-center text-neutral-500 ${orientation === "vertical" ? "px-16" : "px-32"}`}>
      <div className="text-center">
        <Loader2 className="h-10 w-10 animate-spin mx-auto text-[hsl(var(--brand-green-strong))] mb-6" />
        <p className="text-xl">Aktuelle Meldungen werden geladen.</p>
      </div>
    </div>
  );
}

export function EmptySlide({ orientation }) {
  return (
    <div className={`w-full h-full flex items-center justify-center text-neutral-500 ${orientation === "vertical" ? "px-16" : "px-32"}`}>
      <div className="text-center">
        <p className="text-2xl">Zurzeit liegen keine neuen Meldungen vor.</p>
      </div>
    </div>
  );
}

export function ProgressDot({ active }) {
  return (
    <span
      className="block rounded-full transition-all duration-500"
      style={{
        width: active ? 28 : 8,
        height: 8,
        background: active ? "hsl(var(--brand-green-strong))" : "rgba(0,0,0,0.18)",
      }}
    />
  );
}

export function SeverityBadge({ severity }) {
  const color = SEVERITY_COLOR[severity] || SEVERITY_COLOR.closure;
  const label = SEVERITY_LABEL[severity] || "Sperrung";
  return (
    <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] font-medium" style={{ color }}>
      <span className="inline-flex items-center justify-center h-6 w-6 rounded-full text-white" style={{ background: color }}>
        <AlertTriangle className="h-3.5 w-3.5" />
      </span>
      {label}
    </span>
  );
}

export { AlertTriangle, CalendarDays, MapPin };
